import React, { useState, useRef, useEffect } from "react";
import * as PR from "../../prime-modules/index";
import { logout } from "../../assets/images";
import { data2gosvg, data2goIcon,data2goLogo, esimcrewLogo, awesimIconbg, esimcrewIcon, esimpleLogo, esimpleIcon,esimlinksIconbg, esimLinksLogo, esimLinksIcon, awesimLogo, awesimIcon, gopamweIconbg, gopamweLogo, gopamweIcon} from '../../assets/brands'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { afLogoutReducer } from "../../store/afAuth.slice";
import { useQuery } from "react-query";
import { languageGetApi } from "../../services/affiliateApi";
import { setLanguageIntial, setLanguageStore } from "../../store/language.slice";
import { useTranslation } from "react-i18next";
import { QRCode } from 'react-qrcode-logo';
import { globalConfig } from "../../constants";

const HeaderMenu = () => {

    const appName = process.env.REACT_APP_NAME;
    let logo = data2gosvg;
    let logoIcon = data2goLogo;
    let logoIconBg = data2goIcon
    let languageList = ['en','es','pt']
    let languages = [
        { name: 'English', code: 'EN' },
        { name: 'Spanish', code: 'ES' },
        { name: 'Portuguese', code: 'PT' },
    ]

      if (appName === 'esimcrew') {
        logo = esimcrewLogo;
        logoIcon = esimcrewIcon;
        logoIconBg = esimcrewIcon;
        languageList = ['en', 'es', 'pt', 'tl'];
        languages = [
          { name: 'English', code: 'en' },
          { name: 'Portuguese', code: 'pt' },
          { name: 'Spanish', code: 'es' },
          { name: 'Tagalog', code: 'tl' },
        ];
      } else if (appName === 'esimple') {
        logo = esimpleLogo;
        logoIcon = esimpleIcon;
        logoIconBg = esimpleIcon;
        languageList = ['en', 'nl'];
        languages = [
          { name: 'English', code: 'en' },
          { name: 'Dutch', code: 'nl' },
        ];
      } else if (appName === 'esimlinks') {
        logo = esimLinksLogo;
        logoIcon = esimLinksIcon;
        logoIconBg = esimlinksIconbg;
        languageList = ['en', 'es', 'pt', 'fr', 'de'];
        languages = [
          { name: 'English', code: 'EN' },
          { name: 'French', code: 'FR' },
          { name: 'German', code: 'DE' },
          { name: 'Portuguese', code: 'PT' },
          { name: 'Spanish', code: 'ES' },
        ];
      }
      else if (appName === 'gopamwe' || appName === 'gopamwe-corporate') {
        logo = gopamweLogo;
        logoIcon = gopamweIcon;
        logoIconBg = gopamweIconbg;
        languageList = ['en', 'es', 'pt', 'fr', 'de'];
        languages = [
          { name: 'English', code: 'EN' },
          { name: 'Portuguese', code: 'PT' },
          { name: 'Spanish', code: 'ES' },
        ];
      }
      else if (appName === 'awesim') {
        logo = awesimLogo;
        logoIcon = awesimIcon;
        logoIconBg = awesimIconbg;
      }
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const i18Language = i18n.language.split('-')[0]
    const lnFromStore = useSelector(state => state.language);
    const language = languageList.includes(i18Language) ? i18Language : 'en'
    const pathname = window.location.pathname?.toLowerCase();
    const storeLanguage = useSelector(state => state.language);
    const { affiliate } = storeLanguage?.activelang
    const languageAssert = useSelector(state => state.language)
    const { afIsAuthenticated } = useSelector(state => state.afAuth)
    const { afUserData } = useSelector(state => state.afAuth)
    const dispatch = useDispatch();
    const toast = useRef(null);
    const isCorporate = appName?.includes("corporate");

    const [visible, setVisible] = useState(false);
    const [affiliateLinkVisible, setAffiliateLinkVisible] = useState(false);

    const qrRef = useRef({});
    const affTarget = process.env.REACT_APP_AFF_URL;
    const affTargetUrl = (appName === 'data2go' || appName === 'esimcrew') ? `${affTarget}&referrer=afid=` : `${affTarget}?afid=`;
    const affiliateLink = afIsAuthenticated ? `${affTargetUrl}${afUserData?.afId }` : '';   

    const copyToClipboard = (affiliateLink) => {
        navigator.clipboard.writeText(affiliateLink);
        toast.current.show({
            severity: 'success',
            summary: 'Copied',
            detail: `Link copied to clipboard!`,
            life: globalConfig?.toastDisplayTime,
        });
    };
    
    const downloadQRCode = async (id) => {
        const canvas = qrRef.current[id].querySelector('canvas');
        const image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = image;
        link.download = 'affiliate_qrcode.png';
        link.click();
    };

    const changeLanguage = e => {
        const ln = e.value.code.toLocaleLowerCase();
        i18n.changeLanguage(ln);
    };

    const logoutHandler = () => {
        dispatch(afLogoutReducer()); setVisible(false);
    }
    useEffect(() => {
        if (!!languageAssert[language]) {
            dispatch(setLanguageStore(languageAssert[language]))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language, dispatch])

    const onSuccess = v => { dispatch(setLanguageIntial({ k: language, v })) };
    // useQuery(['LABELS', language], languageGetApi.bind(null, language, "labels-aff-new"), {
    //     enabled: !lnFromStore[language],
    //     onSuccess
    // });

    useQuery(['AFFILIATE', language], languageGetApi.bind(null, language, "affiliate-labels-new"), {
        enabled: !lnFromStore[language],
        onSuccess
    });

    useQuery(['VALIDATIONS', language], languageGetApi.bind(null, language, "validations-new"), {
        enabled: !lnFromStore[language],
        onSuccess
    });

    const start = (
        <div className="header-left">
            <Link to={afIsAuthenticated || pathname !== '/' ? '/' : process.env.REACT_APP_PARTNER_URL} target={!afIsAuthenticated && pathname === '/' && '_blank'}>
                {afIsAuthenticated ?
                    <PR.Image src={logoIcon} alt="data2go logo" className="logo-icon" /> :
                    <div><PR.Image src={logo} alt="data2go logo" className="logo-img hide-on-mobile" />
                    <PR.Image src={logoIcon} alt="data2go logo" className="logo-img show-on-mobile" /></div>
                }
            </Link>
            {afIsAuthenticated && (
                <div className="affiliate-link-desktop">
                    <h1>{affiliate?.AFFNL0137 || "Welcome"} <span>{afUserData?.firstName}</span></h1>
                    <span
                    title="Affiliate Link"
                    onClick={() => setAffiliateLinkVisible(true)}
                    className="pi pi-info-circle"
                    ></span>
                </div>
            )}
        </div>
    );

    const end = (
        <div className="header-right flex align-items-center gap-3">
            <div className="card">
                <PR.Dropdown
                    value={languages?.filter(el => el.code.toLocaleLowerCase() === language)?.[0]}
                    onChange={changeLanguage}
                    options={languages}
                    optionLabel="name"
                    placeholder="English"
                    className="language-dropdown"
                    panelClassName="language-panel"
                />
            </div>
            {afIsAuthenticated && appName === "data2go" &&
            <a
                href="/assets/data2go-admin-guide.pdf"
                download
                rel="noopener noreferrer"
                aria-label="Download admin help guide (PDF)"
                className="help-link">
                <i className="pi pi-question-circle"></i> Help
            </a>
            }

            {afIsAuthenticated
                ? <div className="card flex justify-content-center">
                    <div className="user-name" onClick={() => setVisible(true)}>
                        <i title="Affiliate Link" className="pi pi-power-off" />
                        <span>{affiliate?.AFFNL0025} </span>
                    </div>
                </div>
                : pathname === "/" ? <PR.Button onClick={navigate.bind(null, '/affiliate-signup')} label={affiliate?.AFFNL0007} className="login-button" /> : <PR.Button onClick={navigate.bind(null, '/')} label={affiliate?.AFFNL0014} className="login-button" />
            }
        </div>
    );

    return (
        <>
         <PR.Toast ref={toast} />
            <section className="header-menu-section">
                <div className="grid grid-nogutter">
                    <div className="col-12">
                        <PR.Menubar start={start} end={end} />
                    </div>
                </div>
            </section>
            <PR.Dialog visible={visible} onHide={() => { if (!visible) return; setVisible(false); }} className="logout-dialog">
                <div className="flex align-items-center gap-3">
                    <div className="logout-icon"><PR.Image src={logout} /></div>
                    <h2>{affiliate?.AFFNL0025}</h2>
                </div>
                <div className="content">
                    <p>{affiliate?.AFFNL0026}</p>
                    <div className="flex align-items-center gap-3">
                        <PR.Button label={affiliate?.AFFNL0027} className="logout-buttons cancel" onClick={() => setVisible(false)} />
                        <PR.Button label={affiliate?.AFFNL0025} className="logout-buttons" onClick={logoutHandler} />
                    </div>
                </div>
            </PR.Dialog>
            <PR.Dialog visible={affiliateLinkVisible}
                onHide={() => { if (!affiliateLinkVisible) return; setAffiliateLinkVisible(false); }}
                className="create-voucher-dailog affiliate-link-modal"
                header={ isCorporate ? affiliate?.AFFNL0147 : affiliate?.AFFNL0138 || "Affiliate Details"} 
                draggable={false} dismissableMask={true} resizable={false}
                >
                <div className="content">
                    <div className="affiliate-link-container">
                        {/* <span className="affiliate-link-label">{afUserData?.firstName}</span> */}
                        <div className="link-block">
                            <span className="affiliate-link">{affiliateLink}</span>
                            <div className="right">
                                <span className="copy">
                                    <span title="Copy Affiliate Link"
                                        className="pi pi-copy"
                                        onClick={() => copyToClipboard(affiliateLink)}
                                    />
                                </span>
                                {<>
                                    <div className="copy" ref={(el) => qrRef.current[affiliateLink] = el} style={{ display: 'none' }}>
                                        <QRCode
                                            id={affiliateLink}
                                            size={500}
                                            logoImage={logoIconBg}
                                            logoWidth={50}
                                            logoHeight={50}
                                            value={affiliateLink}
                                        />
                                    </div>
                                    <span
                                        className="pi pi-download"
                                        title="Download QR Code"
                                        onClick={() => downloadQRCode(affiliateLink)}
                                    />
                                </>
                                }
                            </div>
                        </div>
                        <div className="qrcode-image" ref={(el) => qrRef.current[affiliateLink] = el}>
                            <QRCode
                                id={affiliateLink}
                                size={500}
                                logoImage={logoIconBg}
                                logoWidth={50}
                                logoHeight={50}
                                value={affiliateLink}
                            />
                        </div>
                    </div>
                </div>
            </PR.Dialog>
        </>
    );
};

export default HeaderMenu;
